export default __webpack_public_path__ + "static/media/abstract1.187bce4f.svg";